module.exports = __webpack_public_path__ + "img/illustrative-kiln-matrix 3.e9d3e474.svg";